import React, { useState, useEffect } from 'react';
import {
  getUsertemplateGenerations,
  getTemplateUserGenerations,
} from '../../utils/templatesApi';
import Users from './Users';
import Templates from './Templates';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers-pro/LocalizationProvider';
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import Box from '@mui/material/Box';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import ClearIcon from '@mui/icons-material/Clear';
import { Tooltip, IconButton } from '@mui/material';

dayjs.extend(relativeTime);
const DashBoard = ({ renderComponent }) => {
  const [Options, setOptions] = useState([]);
  const [loading, setLoading] = React.useState(false);
  const [value, setValue] = React.useState([null, null]);

  const usersList = async () => {
    const filters = {
      startDate: value?.[0] ? dayjs(value[0]).toISOString() : undefined,
      endDate: value?.[1] ? dayjs(value[1]).toISOString() : undefined,
    };
    try {
      setLoading(true);
      const res = await getUsertemplateGenerations(filters);
      setOptions(res);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error('Error fetching templates:', error);
    }
  };

  const templatesList = async () => {
    const filters = {
      startDate: value?.[0] ? dayjs(value[0]).toISOString() : undefined,
      endDate: value?.[1] ? dayjs(value[1]).toISOString() : undefined,
    };
    try {
      setLoading(true);
      const res = await getTemplateUserGenerations(filters);
      setOptions(res);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error('Error fetching templates:', error);
    }
  };

  useEffect(() => {
    const [start, end] = value;

    if (renderComponent === 'users') {
      if ((start && end) || (!start && !end)) {
        usersList();
      }
    } else {
      if ((start && end) || (!start && !end)) {
        templatesList();
      }
    }
  }, [renderComponent,value]);

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Box sx={{ p: 2 }}>
          <DateRangePicker
            startText="Start"
            endText="End"
            value={value}
            onChange={(newValue) => setValue(newValue)}
            sx={{
              width: '300px',
            }}
          />
          {value[0] && value[1] && (
            <Tooltip title="Clear Date Range Filter">
              <IconButton
                onClick={() => {
                  setValue([null, null]);
                }}
              >
                <ClearIcon />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      </LocalizationProvider>
      {renderComponent === 'users' ? (
        <Users Options={Options} loading={loading} value={value} />
      ) : (
        <Templates Options={Options} loading={loading} value={value} />
      )}
    </>
  );
};

export default DashBoard;
